import * as React from 'react';
import { MessageBox } from 'src/domains/players/webview/ui/MessageBoxWrapper/MessageBox';
import { observer } from 'src/utils/mobx-react';
import { MessageBoxState } from 'src/domains/players/state/MessageBoxState';
import { useCommon } from 'src/domains/common/Common';

export const MessageBoxWrapper = observer('MessageBoxWrapper', () => {
    const common = useCommon();
    const messageBox = MessageBoxState.get(common);
    if (messageBox.messageForView === null) {
        return null;
    }

    return (
        <MessageBox
            title={messageBox.messageForView.title}
            message={messageBox.messageForView.message}
            onClose={messageBox.onClose}
        />
    );
});
